module.exports = __webpack_public_path__ + "static/media/Curoflow_telemedicine_platform_for_healthcare_professionals.16779e94.webp";